angular.module('tf.directives')
    .directive('cloudEditorGalleryItem', ['$state', function ($state) {
        return {
            restrict: 'E',
            replace: true,
            scope: {},
            templateUrl: 'js/components/cloudEditorGalleryItem/cloudEditorGalleryItem.html',
            controller: 'CloudEditorGalleryItemController',
            link: function(scope, element) {
                element.on('click', function() {
                    scope.$apply(function() {
                        $state.go('app.cloudeditor'); 
                    });
                });
            }
        };
    }])
    .controller('CloudEditorGalleryItemController', ['$scope', 'Session', function($scope, Session) {
        $scope.defaultImage = "../img/cloud-template-icon.svg";
    }]);
    

